module.exports = __webpack_public_path__ + "65a72645ae2e7e3f85d48608a7d0c790.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/venn_content_commerce_mobile.svg
// module id = 222
// module chunks = 0